﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.staffBlockHeadersFilter
 * @description
 * # staffBlockHeadersFilter
 */

/*jshint sub:true*/
angular.module('ntmApp')
  .filter('staffBlockHeadersFilter', function () {

      return function (items, selectedStaff, forecastFilter, showOnlyPinned) {

          if (items) {
              var filteredByStaffName = selectedStaff && selectedStaff.id ? items.filter(function (item) {
                  return item.personId === selectedStaff.id;
              }) : items;

              var filtered = filteredByStaffName.filter(function (item) {
                  var isAppliedByFilters = forecastFilter.isBlockHeaderApplied(item);

                  if (showOnlyPinned) {
                      return isAppliedByFilters && item.pinned;
                  }

                  return isAppliedByFilters;
              });

              var pinnedItems = items.filter(function (item) {
                  return item.pinned;
              });

              return filtered.uniqueUnion(pinnedItems);
          }

          return items;
      };
  });